export const PILL_STATUS_TYPES = {
  GOAL: 'goal',
  KIT: 'kit',
} as const

const TAG_COLORS = {
  RED: 'red',
  GREEN: 'green',
  YELLOW: 'yellow',
  PRIMARY: 'primary',
} as const

const GOAL_STATUS = {
  not_achieved: TAG_COLORS.YELLOW,
  achieved: TAG_COLORS.GREEN,
} as const

const KIT_STATUS = {
  archived: TAG_COLORS.RED,
  canceled: TAG_COLORS.RED,
  failed: TAG_COLORS.RED,
  invalid: TAG_COLORS.RED,
  failed_delivery: TAG_COLORS.RED,
  out_of_stock: TAG_COLORS.RED,
  pending_order_retry: TAG_COLORS.YELLOW,
  returned_to_sender: TAG_COLORS.YELLOW,
  created: TAG_COLORS.PRIMARY,
  new: TAG_COLORS.PRIMARY,
  shipped: TAG_COLORS.PRIMARY,
  delivered: TAG_COLORS.GREEN,
} as const

export const STATUS_COLORS: Record<StatusType, Record<string, string>> = {
  [PILL_STATUS_TYPES.GOAL]: GOAL_STATUS,
  [PILL_STATUS_TYPES.KIT]: KIT_STATUS,
} as const

export const I18N_PREFIXES: Record<StatusType, string> = {
  [PILL_STATUS_TYPES.GOAL]: 'GOALS.STATUS',
  [PILL_STATUS_TYPES.KIT]: 'KIT_DELIVERY.STATUS',
} as const

export type StatusType = typeof PILL_STATUS_TYPES[keyof typeof PILL_STATUS_TYPES]
export type GoalStatus = keyof typeof STATUS_COLORS[typeof PILL_STATUS_TYPES.GOAL]
export type KitStatus = keyof typeof STATUS_COLORS[typeof PILL_STATUS_TYPES.KIT]
